import { Currency, Locale } from '@synergy/models';

import { WishListItem, WishListSupplier } from '../wish-list';
import { WishListSupplierDto } from '../dto/wish-list-dto';
import { mapWishListItem } from './wish-list-item-mapper';

export const mapWishListSupplier = (
    supplier: WishListSupplierDto,
    locales: Locale[],
    currency: Currency
): WishListSupplier | null => {
    const items = supplier.items.map(item => mapWishListItem(item, locales, currency));
    if (items.some(item => item === null)) {
        return null;
    }

    return {
        id: supplier.id,
        name: supplier.name,
        image: supplier.image,
        items: items as WishListItem[],
    };
};
